import * as React from 'react';
import { Checkbox, Text, TextField } from '@serodigital/ui-components';
import { useFieldArray, useFormState } from 'react-hook-form';
import { Degree } from '../degree';

export const FormZone = ({ name, index, register, error, defaultChecked }) => {
  const active = `zones.${index}.active`;
  const { onChange: onChangeHandler, ...props } = register(active);
  const errorTemp = error[`zones.${index}.temperature`];
  return (
    <div className="flex justify-between border-b border-grey-neutral">
      <div className="flex items-center space-x-8">
        <Checkbox
          data-qa={`zones-${index}-checkbox`}
          checked={defaultChecked}
          onChangeHandler={onChangeHandler}
          {...props}
        />
        <Text size="large">{name}</Text>
      </div>
      <div className="flex mt-28">
        <TextField
          data-qa={`zones-${index}-temperature`}
          type="number"
          error={Boolean(errorTemp)}
          errorMessage={errorTemp}
          step="1"
          endIcon={<Degree fill="#575756" />}
          label="Temperature"
          className="!pr-40"
          {...register(`zones.${index}.temperature`)}
        />
      </div>
    </div>
  );
};

export const FormZones = ({ zones, control, register }) => {
  const { fields } = useFieldArray({
    control,
    name: 'zones',
  });
  const { errors, defaultValues } = useFormState({ control });
  return (
    <div data-qa="form-zones" className={fields.length > 0 && 'border-t border-grey-neutral'}>
      {fields.map((field, index) => (
        <FormZone
          name={zones[index].description}
          index={index}
          register={register}
          key={field.id}
          error={errors}
          defaultChecked={defaultValues?.zones?.[index].active}
        />
      ))}
    </div>
  );
};
